import { Component, OnInit, ViewChild } from '@angular/core';
import { dummyDataRewardRequest, IDataDescriptionMapping, IReward } from '../../retailers.interface';
import { MatSort, Sort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { TableColumn } from '@shared/interface/table.interface';
import { IQueryParams } from '@shared/interface/urlparam.interface';
import { STRING_CONSTANTS } from '@config/constants/string.constants';
import { BaseDatasource } from '@shared/base/base.datasource';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-retailer-reward',
  templateUrl: './reward.component.html',
  styleUrls: ['./reward.component.scss'],
})
export class RewardComponent implements OnInit {
  @ViewChild(MatSort, { static: false }) matSort: MatSort;

  tableColumns: TableColumn[];
  displayedColumns: string[];
  rewardList: IReward[] = dummyDataRewardRequest;
  STRING_CONSTANTS = STRING_CONSTANTS;
  baseDatasource: BaseDatasource<IReward>;
  tableColumn = ['id', 'status', 'action'];
  dataHistoryHeader: BehaviorSubject<IDataDescriptionMapping | undefined> = new BehaviorSubject<IDataDescriptionMapping | undefined>(undefined);
  brandId: string;
  iconFrame = STRING_CONSTANTS.ICON.IC_FRAME;
  iconCoin = STRING_CONSTANTS.ICON.IC_COIN;
  iconNone = STRING_CONSTANTS.ICON.IC_COIN_NONE;

  constructor(private router: Router, private activeRoute: ActivatedRoute) {}

  ngOnInit(): void {
    this.setTableData();
    this.getDataDescription();
  }

  handleAction(): void {}

  // TABLE
  setTableData() {
    this.tableColumns = [
      {
        title: 'NAMA PRODUK',
        key: 'product_name',
      },
      {
        title: 'JUMLAH POINT',
        key: 'point_total',
      },
      {
        title: 'TANGGAL GENERATE',
        key: 'generate_date',
        isSortable: true,
      },
      {
        title: 'ACTION',
        key: 'action',
      },
    ];
    this.displayedColumns = this.tableColumns.map((item) => item.key);
    this.baseDatasource = new BaseDatasource();
    this.baseDatasource.isFinishLoadingSubject.next(true);
    if (this.rewardList) {
      this.baseDatasource.tableSubject.next(this.rewardList);
    }
  }

  sortTable(param: Sort) {
    const sortby = this.tableColumns.find((column) => column.key === param.active);
    param.active = sortby?.key ?? '';
    this.sortDataSource(param);
  }

  sortDataSource(sortParams: Sort) {
    if (sortParams.direction) {
      const dataParam: IQueryParams = {
        sort: sortParams.active + ',' + sortParams.direction,
      };
      this.router
        .navigate([], {
          queryParams: {
            ...dataParam,
          },
          queryParamsHandling: 'merge',
        })
        .then(() => null);
    } else {
      const snapshot = this.activeRoute.snapshot;
      const dataParam = { ...snapshot.queryParams };
      delete dataParam.sort;
      this.router.navigate([], { queryParams: dataParam }).then(() => null);
    }
  }


  getDataDescription() {

    this.dataHistoryHeader.next([
      { value: '1.000', icon: this.iconCoin, label: 'Maxxi Point' },
      { value: 'Silver', icon: this.iconFrame },
    ]);
  }

  initPageInfo() {
    this.baseDatasource.tableSubject.subscribe((data) => {
      this.rewardList = data;
    });
  }
}
